module.exports = __webpack_public_path__ + "img/Illustration.3cc1ce15.jpg";